import { TaskTypeSchema, ITaskType } from "@app/api/task-types/helper-schemas";
import { store } from "index";
import {
	getDefaultStorageSettings,
	getDefaultReducer,
	filterByLoadTime,
	loadFromStorage,
	listenToLocalStorageChange,
} from "m-model-common";
import { getJoiObjectKeys, validateStorage } from "m-model-joi";
import { createModel, RawInstances, createCRUDActionTypes } from "m-model-core";
import { MAX_LOAD_TIME_DIFF, MIN_LOAD_TIME } from "./constants";
import { CourseCommonMetaInfo } from "./meta-info";

const keyOfId = "_id";
type IdKey = typeof keyOfId;
type DOC = ITaskType;
export type IStateTaskTypes = RawInstances<IdKey, DOC>;

// ==============Base Model=================

const dockeys = getJoiObjectKeys<DOC>(TaskTypeSchema);
const storage = localStorage;
const actionTypes = createCRUDActionTypes("taskType");
const storageSettings = getDefaultStorageSettings("taskTypes");
const metaInformationName = "taskTypesMetaInformation";

const isLoadedRecentlyEnough = filterByLoadTime(
	MAX_LOAD_TIME_DIFF,
	MIN_LOAD_TIME
);

const Model = createModel<IdKey, DOC>({
	keyOfId,
	getInstances: (() => store.getState().taskTypes) as any,
	dispatch: (action => store.dispatch(action)) as any,
	subscribe: (listener => store.subscribe(listener)) as any,
	actionTypes,
	dockeys,
	loadInstancesFromStorage: () =>
		loadFromStorage({
			storage,
			key: storageSettings.itemName,
			validateWholeData: validateStorage("ObjectId", TaskTypeSchema),
			filter: isLoadedRecentlyEnough,
		}),
});

// ==============Main Model=================

export class TaskType extends Model {
	static initialize() {
		const info = super.initialize();
		if (info.loadedAll) this.meta.initialize();
		else this.meta.clear();
		return info;
	}

	static meta = new CourseCommonMetaInfo(storage, metaInformationName);
}

export type ITaskTypeInstance = TaskType;
export type ITaskTypeModel = typeof TaskType;

// ==============ETC=================

listenToLocalStorageChange(storage, metaInformationName, TaskType.meta);

export const taskTypesReducer = getDefaultReducer(
	storageSettings,
	() => TaskType
);
